import withOtherOffers from './with-other-offers';

export default withOtherOffers;